(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

parcelRegister("iPsZ0", function(module, exports) {

$parcel$export(module.exports, "wireCopy", () => $db5378cf31720742$export$7167b346a0f58311);
// Putting a finished picture on the clipboard.
//
// The people these tools are for paste into Discord more often than they
// attach a file, so a copy button sits next to every "Save image" on the tools
// that produce one picture. It is a convenience on top of saving, never a
// replacement, and on a browser that cannot write images to the clipboard it
// is simply not shown.
/** Whether this browser can put an image on the clipboard at all. */ function $db5378cf31720742$export$9cdf378d4048dd07() {
    return Boolean(window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.write === 'function' && typeof window.ClipboardItem === 'function');
}
/**
 * The picture as PNG, the one image type every clipboard takes. A JPEG or WebP
 * result is drawn once more and re-encoded; nothing about it changes but the
 * container, and the saved file keeps the format that was picked.
 */ async function $db5378cf31720742$var$asPng(blob) {
    if (blob.type === 'image/png') return blob;
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    canvas.getContext('2d').drawImage(bitmap, 0, 0);
    bitmap.close();
    return new Promise((resolve, reject)=>{
        canvas.toBlob((png)=>png ? resolve(png) : reject(new Error('Could not prepare the image')), 'image/png');
    });
}
function $db5378cf31720742$var$tell(message, kind) {
    if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, kind);
}
function $db5378cf31720742$export$7167b346a0f58311({ button: button, mirror: mirror, collect: collect }) {
    if (!button || !$db5378cf31720742$export$9cdf378d4048dd07()) return;
    button.hidden = false;
    if (mirror) {
        const follow = ()=>{
            button.disabled = mirror.disabled;
        };
        follow();
        new MutationObserver(follow).observe(mirror, {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        });
    }
    const label = button.querySelector('[data-copy-label]');
    const idle = label ? label.textContent : '';
    button.addEventListener('click', async ()=>{
        try {
            // The item is handed a promise rather than a finished blob: the
            // write has to start inside the click, and rendering a large
            // result can take longer than a browser keeps that window open.
            const png = Promise.resolve(collect()).then((result)=>{
                if (!result || !result.blob) throw new Error('Nothing to copy yet');
                return $db5378cf31720742$var$asPng(result.blob);
            });
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'image/png': png
                })
            ]);
            if (label) {
                label.textContent = 'Copied';
                setTimeout(()=>{
                    label.textContent = idle;
                }, 1600);
            }
            $db5378cf31720742$var$tell('Image copied. Paste it wherever you need it.', 'success');
        } catch (err) {
            $db5378cf31720742$var$tell('The image could not be copied here. Use Save image instead.', 'error');
        }
    });
}

});

// The screenshot tool on /tools/screenshot.
//
// Two jobs that people do in one sitting: cover up what should not be shared,
// then put the result on a background worth posting. Splitting them across two
// pages would mean saving a half-finished picture and picking it up again, so
// they sit on one canvas.
//
// The picture is redrawn from tools/compose.js on every change. Nothing is
// stored as a layer that could get out of step with what is on screen: the boxes
// are a list of rectangles, the rest is a handful of numbers, and the drawing is
// derived from both every time.
// Turning a raw screenshot into the thing people actually post.
//
// One function does the whole picture: the regions the visitor painted over,
// then the card, its corners, its shadow and the ground behind it. Everything
// is derived from the width it is asked to draw at, so the same code renders
// the small preview that has to keep up with a slider and the full size copy
// that gets saved, and the two cannot drift apart.
//
// Regions are stored as fractions of the image rather than pixels, for the same
// reason: a box painted on a 1200 pixel preview has to land in the same place
// on a 3840 pixel export.

var $7JAKl = parcelRequire("7JAKl");
const $75bc29bc43799f66$export$e9828e0bb5e4794c = [
    // First, and what the page starts with: the screenshot as it came, only
    // redacted. Dressing it up is a choice, not something to undo.
    {
        id: 'off',
        label: 'None, as it comes'
    },
    {
        id: 'ocean',
        label: 'Ocean',
        from: '#2563eb',
        to: '#4f46e5'
    },
    {
        id: 'sunset',
        label: 'Sunset',
        from: '#f97316',
        to: '#ec4899'
    },
    {
        id: 'mint',
        label: 'Mint',
        from: '#10b981',
        to: '#06b6d4'
    },
    {
        id: 'dusk',
        label: 'Dusk',
        from: '#334155',
        to: '#0f172a'
    },
    {
        id: 'blush',
        label: 'Blush',
        from: '#fda4af',
        to: '#fdba74'
    },
    {
        id: 'solid',
        label: 'One colour'
    },
    {
        id: 'none',
        label: 'Transparent'
    }
];
/** Shadow strength, as a share of the picture's long edge. */ const $75bc29bc43799f66$var$SHADOWS = {
    none: {
        blur: 0,
        offset: 0,
        alpha: 0
    },
    soft: {
        blur: 0.035,
        offset: 0.012,
        alpha: 0.28
    },
    strong: {
        blur: 0.06,
        offset: 0.025,
        alpha: 0.42
    }
};
const $75bc29bc43799f66$var$RATIOS = {
    auto: null,
    '16:9': 16 / 9,
    '4:3': 4 / 3,
    '1:1': 1
};
/** The three dots on the window bar, in the order every desktop draws them. */ const $75bc29bc43799f66$var$DOTS = [
    '#ff5f57',
    '#febc2e',
    '#28c840'
];
/**
 * A rounded rectangle path.
 *
 * Hand-drawn rather than ctx.roundRect, which Safari only learned recently and
 * which would take the corners off every screenshot on an older one without
 * anything in the interface admitting it.
 */ function $75bc29bc43799f66$var$roundedPath(ctx, x, y, width, height, radius) {
    const r = Math.max(0, Math.min(radius, width / 2, height / 2));
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.arcTo(x + width, y, x + width, y + r, r);
    ctx.lineTo(x + width, y + height - r);
    ctx.arcTo(x + width, y + height, x + width - r, y + height, r);
    ctx.lineTo(x + r, y + height);
    ctx.arcTo(x, y + height, x, y + height - r, r);
    ctx.lineTo(x, y + r);
    ctx.arcTo(x, y, x + r, y, r);
    ctx.closePath();
}
/** Whether this browser can blur while drawing. Safari before 17 cannot. */ let $75bc29bc43799f66$var$filterSupport = null;
function $75bc29bc43799f66$var$supportsFilter() {
    if ($75bc29bc43799f66$var$filterSupport === null) {
        const ctx = document.createElement('canvas').getContext('2d');
        $75bc29bc43799f66$var$filterSupport = typeof ctx.filter === 'string';
    }
    return $75bc29bc43799f66$var$filterSupport;
}
/**
 * The screenshot at `width` x `height`, with every region covered.
 *
 * The clean picture is kept on its own canvas and every region is read from
 * there, so two overlapping boxes both work from the original rather than one
 * of them smearing the other's blur back across the picture.
 */ function $75bc29bc43799f66$var$applyRegions(image, state, width, height) {
    const base = document.createElement('canvas');
    base.width = width;
    base.height = height;
    const baseCtx = base.getContext('2d');
    baseCtx.imageSmoothingEnabled = true;
    baseCtx.imageSmoothingQuality = 'high';
    baseCtx.drawImage(image, 0, 0, width, height);
    if (!state.regions.length) return base;
    const out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    const ctx = out.getContext('2d');
    ctx.drawImage(base, 0, 0);
    for (const region of state.regions){
        const x = Math.round(region.x * width);
        const y = Math.round(region.y * height);
        const w = Math.round(region.w * width);
        const h = Math.round(region.h * height);
        if (w < 1 || h < 1) continue;
        // A solid bar is the only one of the three that removes anything. Blur
        // and pixelation both leave a shadow of the original behind, which is
        // why the interface says so and why this is the default.
        const mode = state.redactMode === 'blur' && !$75bc29bc43799f66$var$supportsFilter() ? 'pixelate' : state.redactMode;
        if (mode === 'fill') {
            ctx.fillStyle = state.redactColour;
            ctx.fillRect(x, y, w, h);
            continue;
        }
        if (mode === 'pixelate') {
            // Scaled down to a handful of blocks and blown straight back up.
            const blocks = Math.max(3, Math.round(Math.min(w, h) / 14));
            const smallW = Math.max(1, Math.round(blocks * (w / Math.min(w, h))));
            const smallH = Math.max(1, Math.round(blocks * (h / Math.min(w, h))));
            const small = document.createElement('canvas');
            small.width = smallW;
            small.height = smallH;
            const smallCtx = small.getContext('2d');
            smallCtx.imageSmoothingEnabled = true;
            smallCtx.drawImage(base, x, y, w, h, 0, 0, smallW, smallH);
            ctx.save();
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage(small, 0, 0, smallW, smallH, x, y, w, h);
            ctx.restore();
            continue;
        }
        // Blurred hard enough that the radius is a share of the box rather than
        // a fixed number of pixels, so a wide banner is not left legible.
        ctx.save();
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.clip();
        ctx.filter = `blur(${Math.max(4, Math.round(Math.min(w, h) / 6))}px)`;
        ctx.drawImage(base, 0, 0);
        ctx.restore();
    }
    return out;
}
/**
 * Where everything lands, without drawing any of it.
 *
 * Separate from the drawing because the interface wants the finished dimensions
 * on every slider move, to show what the export will be, and working that out
 * by composing a second full size copy would redraw a 4K screenshot for a line
 * of text.
 *
 * @param {object} state
 * @param {number} imageWidth  Width to render the screenshot itself at.
 */ /**
 * The state the layout should use. With the backdrop off, everything that only
 * makes sense around a backdrop is off too, so the result is the picture at its
 * own size, whatever the other controls still hold.
 */ function $75bc29bc43799f66$var$dressed(state) {
    if (state.backdrop !== 'off') return state;
    return {
        ...state,
        padding: 0,
        radius: 0,
        shadow: 'none',
        frame: 'none',
        ratio: 'auto'
    };
}
function $75bc29bc43799f66$export$b3219800bda33a1f(rawState, imageWidth) {
    const state = $75bc29bc43799f66$var$dressed(rawState);
    const source = (0, $7JAKl.sizeOf)(state.image);
    const iw = Math.max(1, Math.round(imageWidth));
    const ih = Math.max(1, Math.round(source.height / source.width * iw));
    const long = Math.max(iw, ih);
    const pad = Math.round(state.padding * long);
    const bar = state.frame === 'bar' ? Math.max(16, Math.round(long * 0.03)) : 0;
    const radius = Math.round(state.radius * long);
    const cardW = iw;
    const cardH = ih + bar;
    let outerW = cardW + pad * 2;
    let outerH = cardH + pad * 2;
    // A fixed ratio only ever adds ground on the short side. Cropping to it
    // would cut the screenshot, which is the one thing nobody asking for a
    // square wants.
    const ratio = $75bc29bc43799f66$var$RATIOS[state.ratio];
    if (ratio) {
        if (outerW / outerH < ratio) outerW = Math.round(outerH * ratio);
        else outerH = Math.round(outerW / ratio);
    }
    return {
        iw: iw,
        ih: ih,
        long: long,
        bar: bar,
        radius: radius,
        outerW: outerW,
        outerH: outerH,
        cardW: cardW,
        cardH: cardH,
        cardX: Math.round((outerW - cardW) / 2),
        cardY: Math.round((outerH - cardH) / 2)
    };
}
function $75bc29bc43799f66$export$f672e0b6f7222cd7(rawState, imageWidth) {
    const state = $75bc29bc43799f66$var$dressed(rawState);
    const { iw: iw, ih: ih, long: long, bar: bar, radius: radius, outerW: outerW, outerH: outerH, cardW: cardW, cardH: cardH, cardX: cardX, cardY: cardY } = $75bc29bc43799f66$export$b3219800bda33a1f(state, imageWidth);
    const canvas = document.createElement('canvas');
    canvas.width = outerW;
    canvas.height = outerH;
    const ctx = canvas.getContext('2d');
    const backdrop = $75bc29bc43799f66$export$e9828e0bb5e4794c.find((b)=>b.id === state.backdrop) || $75bc29bc43799f66$export$e9828e0bb5e4794c[0];
    if (backdrop.id === 'solid') {
        ctx.fillStyle = state.backdropColour;
        ctx.fillRect(0, 0, outerW, outerH);
    } else if (backdrop.id !== 'none' && backdrop.id !== 'off') {
        const gradient = ctx.createLinearGradient(0, 0, outerW, outerH);
        gradient.addColorStop(0, backdrop.from);
        gradient.addColorStop(1, backdrop.to);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, outerW, outerH);
    }
    const shadow = $75bc29bc43799f66$var$SHADOWS[state.shadow] || $75bc29bc43799f66$var$SHADOWS.none;
    if (shadow.alpha > 0) {
        // Filled opaque and then covered by the card itself. Only the part that
        // spills past the corners is ever seen.
        ctx.save();
        ctx.shadowColor = `rgba(2, 6, 23, ${shadow.alpha})`;
        ctx.shadowBlur = Math.round(shadow.blur * long);
        ctx.shadowOffsetY = Math.round(shadow.offset * long);
        ctx.fillStyle = '#000000';
        $75bc29bc43799f66$var$roundedPath(ctx, cardX, cardY, cardW, cardH, radius);
        ctx.fill();
        ctx.restore();
    }
    ctx.save();
    $75bc29bc43799f66$var$roundedPath(ctx, cardX, cardY, cardW, cardH, radius);
    ctx.clip();
    if (bar) {
        ctx.fillStyle = state.barColour;
        ctx.fillRect(cardX, cardY, cardW, bar);
        const dot = bar * 0.22;
        let dx = cardX + bar * 0.62;
        for (const colour of $75bc29bc43799f66$var$DOTS){
            ctx.beginPath();
            ctx.arc(dx, cardY + bar / 2, dot, 0, Math.PI * 2);
            ctx.fillStyle = colour;
            ctx.fill();
            dx += dot * 3.2;
        }
    }
    ctx.drawImage($75bc29bc43799f66$var$applyRegions(state.image, state, iw, ih), cardX, cardY + bar, iw, ih);
    ctx.restore();
    return {
        canvas: canvas,
        imageRect: {
            x: cardX,
            y: cardY + bar,
            width: iw,
            height: ih
        }
    };
}



var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $iPsZ0 = parcelRequire("iPsZ0");

var $1Euqv = parcelRequire("1Euqv");
// What the preview is drawn at. Big enough to judge the result, small enough
// that a slider stays smooth over a 4K screenshot.
const $3ac76ebaf6b0238c$var$PREVIEW_WIDTH = 1200;
// The export is capped here. Past it browsers start refusing to allocate the
// canvas, and they do it by handing back a blank one rather than by failing.
const $3ac76ebaf6b0238c$var$MAX_EXPORT_WIDTH = 6000;
// The picture drawn is bigger than the screenshot, sometimes much bigger: a tall
// window forced into 16:9 gains background on both sides until it is wider than
// it is long. Capping the screenshot's own width is therefore not enough, and
// the two limits that actually bite are the longest edge and the total area.
const $3ac76ebaf6b0238c$var$MAX_CANVAS_EDGE = 8192;
const $3ac76ebaf6b0238c$var$MAX_CANVAS_AREA = 40e6;
// Below this a drag was a click at somebody's idea of a steady hand, not an
// attempt to draw a box.
const $3ac76ebaf6b0238c$var$MIN_REGION = 0.004;
const $3ac76ebaf6b0238c$var$FORMATS = {
    'image/png': {
        label: 'PNG',
        extension: 'png',
        quality: undefined
    },
    'image/webp': {
        label: 'WebP',
        extension: 'webp',
        quality: 0.92
    },
    'image/jpeg': {
        label: 'JPEG',
        extension: 'jpg',
        quality: 0.92
    }
};
const $3ac76ebaf6b0238c$var$el = (id)=>document.getElementById(id);
const $3ac76ebaf6b0238c$var$dom = {
    zone: $3ac76ebaf6b0238c$var$el('shotZone'),
    input: $3ac76ebaf6b0238c$var$el('shotInput'),
    empty: $3ac76ebaf6b0238c$var$el('shotEmpty'),
    workspace: $3ac76ebaf6b0238c$var$el('shotWorkspace'),
    stage: $3ac76ebaf6b0238c$var$el('shotStage'),
    canvas: $3ac76ebaf6b0238c$var$el('shotCanvas'),
    overlay: $3ac76ebaf6b0238c$var$el('shotOverlay'),
    redactMode: $3ac76ebaf6b0238c$var$el('shotRedactMode'),
    redactColourRow: $3ac76ebaf6b0238c$var$el('shotRedactColourRow'),
    redactColour: $3ac76ebaf6b0238c$var$el('shotRedactColour'),
    redactWarning: $3ac76ebaf6b0238c$var$el('shotRedactWarning'),
    backdrop: $3ac76ebaf6b0238c$var$el('shotBackdrop'),
    backdropColourRow: $3ac76ebaf6b0238c$var$el('shotBackdropColourRow'),
    backdropColour: $3ac76ebaf6b0238c$var$el('shotBackdropColour'),
    padding: $3ac76ebaf6b0238c$var$el('shotPadding'),
    paddingValue: $3ac76ebaf6b0238c$var$el('shotPaddingValue'),
    radius: $3ac76ebaf6b0238c$var$el('shotRadius'),
    radiusValue: $3ac76ebaf6b0238c$var$el('shotRadiusValue'),
    shadow: $3ac76ebaf6b0238c$var$el('shotShadow'),
    bar: $3ac76ebaf6b0238c$var$el('shotBar'),
    ratio: $3ac76ebaf6b0238c$var$el('shotRatio'),
    format: $3ac76ebaf6b0238c$var$el('shotFormat'),
    boxCount: $3ac76ebaf6b0238c$var$el('shotBoxCount'),
    undo: $3ac76ebaf6b0238c$var$el('shotUndo'),
    clearBoxes: $3ac76ebaf6b0238c$var$el('shotClearBoxes'),
    save: $3ac76ebaf6b0238c$var$el('shotSave'),
    reset: $3ac76ebaf6b0238c$var$el('shotReset'),
    saveAccount: $3ac76ebaf6b0238c$var$el('toolSaveAccount'),
    savePanel: $3ac76ebaf6b0238c$var$el('toolSavePanel'),
    saveList: $3ac76ebaf6b0238c$var$el('toolSaveList'),
    saveError: $3ac76ebaf6b0238c$var$el('toolSaveError'),
    meta: $3ac76ebaf6b0238c$var$el('shotMeta'),
    error: $3ac76ebaf6b0238c$var$el('shotError'),
    live: $3ac76ebaf6b0238c$var$el('shotLive')
};
const $3ac76ebaf6b0238c$var$state = {
    image: null,
    file: null,
    regions: [],
    redactMode: 'fill',
    redactColour: '#0f172a',
    backdrop: 'off',
    backdropColour: '#e2e8f0',
    padding: 0.06,
    radius: 0.014,
    shadow: 'soft',
    frame: 'none',
    barColour: '#e2e8f0',
    ratio: 'auto'
};
let $3ac76ebaf6b0238c$var$composed = null; // The last result from compose, for the pointer maths.
let $3ac76ebaf6b0238c$var$selected = -1; // Index into state.regions, or -1.
let $3ac76ebaf6b0238c$var$drawing = null; // The rectangle currently being dragged out.
let $3ac76ebaf6b0238c$var$frameRequested = false;
/* ---------------------------------------------------------------- rendering */ function $3ac76ebaf6b0238c$var$render() {
    if (!$3ac76ebaf6b0238c$var$state.image) return;
    const source = (0, $7JAKl.sizeOf)($3ac76ebaf6b0238c$var$state.image);
    $3ac76ebaf6b0238c$var$composed = (0, $75bc29bc43799f66$export$f672e0b6f7222cd7)($3ac76ebaf6b0238c$var$state, Math.min($3ac76ebaf6b0238c$var$PREVIEW_WIDTH, source.width));
    $3ac76ebaf6b0238c$var$dom.canvas.width = $3ac76ebaf6b0238c$var$composed.canvas.width;
    $3ac76ebaf6b0238c$var$dom.canvas.height = $3ac76ebaf6b0238c$var$composed.canvas.height;
    $3ac76ebaf6b0238c$var$dom.canvas.getContext('2d').drawImage($3ac76ebaf6b0238c$var$composed.canvas, 0, 0);
    $3ac76ebaf6b0238c$var$dom.overlay.width = $3ac76ebaf6b0238c$var$composed.canvas.width;
    $3ac76ebaf6b0238c$var$dom.overlay.height = $3ac76ebaf6b0238c$var$composed.canvas.height;
    $3ac76ebaf6b0238c$var$drawOverlay();
    // The squares behind the preview only mean something while the picture
    // actually has nothing behind it.
    $3ac76ebaf6b0238c$var$dom.stage.classList.toggle('is-transparent', $3ac76ebaf6b0238c$var$state.backdrop === 'none' || $3ac76ebaf6b0238c$var$state.backdrop === 'off');
    const out = $3ac76ebaf6b0238c$var$exportSize();
    const capped = $3ac76ebaf6b0238c$var$exportWidth() < Math.min(source.width, $3ac76ebaf6b0238c$var$MAX_EXPORT_WIDTH);
    $3ac76ebaf6b0238c$var$dom.meta.textContent = `${source.width} x ${source.height} source, saves at ${out.width} x ${out.height}` + (capped ? ' (limited to what a canvas can hold)' : '');
}
function $3ac76ebaf6b0238c$var$schedule() {
    if ($3ac76ebaf6b0238c$var$frameRequested) return;
    $3ac76ebaf6b0238c$var$frameRequested = true;
    requestAnimationFrame(()=>{
        $3ac76ebaf6b0238c$var$frameRequested = false;
        $3ac76ebaf6b0238c$var$render();
    });
}
/** The boxes, drawn over the picture so they can be picked up again. */ function $3ac76ebaf6b0238c$var$drawOverlay() {
    if (!$3ac76ebaf6b0238c$var$composed) return;
    const ctx = $3ac76ebaf6b0238c$var$dom.overlay.getContext('2d');
    ctx.clearRect(0, 0, $3ac76ebaf6b0238c$var$dom.overlay.width, $3ac76ebaf6b0238c$var$dom.overlay.height);
    const line = Math.max(2, Math.round($3ac76ebaf6b0238c$var$composed.canvas.width / 600));
    const boxes = $3ac76ebaf6b0238c$var$drawing ? [
        ...$3ac76ebaf6b0238c$var$state.regions,
        $3ac76ebaf6b0238c$var$drawing
    ] : $3ac76ebaf6b0238c$var$state.regions;
    boxes.forEach((region, index)=>{
        const box = $3ac76ebaf6b0238c$var$toCanvas(region);
        const active = index === $3ac76ebaf6b0238c$var$selected || $3ac76ebaf6b0238c$var$drawing && index === boxes.length - 1;
        // Two strokes, a dark one under a light one, so the outline is visible
        // whatever it happens to be sitting on.
        ctx.lineWidth = line + 2;
        ctx.strokeStyle = 'rgba(2, 6, 23, .55)';
        ctx.setLineDash([]);
        ctx.strokeRect(box.x, box.y, box.width, box.height);
        ctx.lineWidth = line;
        ctx.strokeStyle = active ? '#38bdf8' : 'rgba(255, 255, 255, .95)';
        ctx.setLineDash(active ? [] : [
            line * 3,
            line * 2
        ]);
        ctx.strokeRect(box.x, box.y, box.width, box.height);
    });
    ctx.setLineDash([]);
}
/* -------------------------------------------------------- coordinate maths */ /** A stored region, in canvas pixels. */ function $3ac76ebaf6b0238c$var$toCanvas(region) {
    const rect = $3ac76ebaf6b0238c$var$composed.imageRect;
    return {
        x: rect.x + region.x * rect.width,
        y: rect.y + region.y * rect.height,
        width: region.w * rect.width,
        height: region.h * rect.height
    };
}
/** A pointer event, as a position on the screenshot from 0 to 1. */ function $3ac76ebaf6b0238c$var$toImage(event) {
    const rect = $3ac76ebaf6b0238c$var$dom.overlay.getBoundingClientRect();
    const x = (event.clientX - rect.left) * ($3ac76ebaf6b0238c$var$dom.overlay.width / rect.width);
    const y = (event.clientY - rect.top) * ($3ac76ebaf6b0238c$var$dom.overlay.height / rect.height);
    const image = $3ac76ebaf6b0238c$var$composed.imageRect;
    return {
        x: Math.min(1, Math.max(0, (x - image.x) / image.width)),
        y: Math.min(1, Math.max(0, (y - image.y) / image.height))
    };
}
/** The last box drawn over this point, which is the one on top. */ function $3ac76ebaf6b0238c$var$regionAt(point) {
    for(let i = $3ac76ebaf6b0238c$var$state.regions.length - 1; i >= 0; i -= 1){
        const r = $3ac76ebaf6b0238c$var$state.regions[i];
        if (point.x >= r.x && point.x <= r.x + r.w && point.y >= r.y && point.y <= r.y + r.h) return i;
    }
    return -1;
}
/* ------------------------------------------------------------- interaction */ function $3ac76ebaf6b0238c$var$wireDrawing() {
    let origin = null;
    let pointerId = null;
    $3ac76ebaf6b0238c$var$dom.overlay.addEventListener('pointerdown', (event)=>{
        if (!$3ac76ebaf6b0238c$var$composed || event.button !== 0 && event.pointerType === 'mouse') return;
        pointerId = event.pointerId;
        $3ac76ebaf6b0238c$var$dom.overlay.setPointerCapture(pointerId);
        origin = $3ac76ebaf6b0238c$var$toImage(event);
        $3ac76ebaf6b0238c$var$drawing = {
            x: origin.x,
            y: origin.y,
            w: 0,
            h: 0
        };
    });
    $3ac76ebaf6b0238c$var$dom.overlay.addEventListener('pointermove', (event)=>{
        if (pointerId === null || event.pointerId !== pointerId) return;
        const point = $3ac76ebaf6b0238c$var$toImage(event);
        $3ac76ebaf6b0238c$var$drawing = {
            x: Math.min(origin.x, point.x),
            y: Math.min(origin.y, point.y),
            w: Math.abs(point.x - origin.x),
            h: Math.abs(point.y - origin.y)
        };
        $3ac76ebaf6b0238c$var$drawOverlay();
    });
    const finish = (event)=>{
        if (pointerId === null || event && event.pointerId !== pointerId) return;
        try {
            $3ac76ebaf6b0238c$var$dom.overlay.releasePointerCapture(pointerId);
        } catch (err) {
        // The pointer is already gone, which is the state we wanted anyway.
        }
        pointerId = null;
        const box = $3ac76ebaf6b0238c$var$drawing;
        $3ac76ebaf6b0238c$var$drawing = null;
        if (box && box.w >= $3ac76ebaf6b0238c$var$MIN_REGION && box.h >= $3ac76ebaf6b0238c$var$MIN_REGION) {
            $3ac76ebaf6b0238c$var$state.regions.push(box);
            $3ac76ebaf6b0238c$var$selected = $3ac76ebaf6b0238c$var$state.regions.length - 1;
            $3ac76ebaf6b0238c$var$paintBoxCount();
            $3ac76ebaf6b0238c$var$render();
            return;
        }
        // Too small to be a box, so it was a click: pick up whatever is there.
        $3ac76ebaf6b0238c$var$selected = origin ? $3ac76ebaf6b0238c$var$regionAt(origin) : -1;
        $3ac76ebaf6b0238c$var$paintBoxCount();
        $3ac76ebaf6b0238c$var$drawOverlay();
    };
    $3ac76ebaf6b0238c$var$dom.overlay.addEventListener('pointerup', finish);
    $3ac76ebaf6b0238c$var$dom.overlay.addEventListener('pointercancel', finish);
    document.addEventListener('keydown', (event)=>{
        if (event.key !== 'Delete' && event.key !== 'Backspace') return;
        // Not while someone is typing a colour or a number.
        if (event.target.matches('input, textarea, select')) return;
        if ($3ac76ebaf6b0238c$var$selected < 0) return;
        event.preventDefault();
        $3ac76ebaf6b0238c$var$removeRegion($3ac76ebaf6b0238c$var$selected);
        $3ac76ebaf6b0238c$var$announceBox(`Removed. ${$3ac76ebaf6b0238c$var$state.regions.length} ${$3ac76ebaf6b0238c$var$state.regions.length === 1 ? 'box' : 'boxes'} left.`);
    });
}
/* ------------------------------------------------------------- keyboard --- */ // One press moves or sizes a box by this share of the picture; with Alt, by a
// fifth of it, for the last pixel of a token's edge.
const $3ac76ebaf6b0238c$var$KEY_STEP = 0.01;
const $3ac76ebaf6b0238c$var$FINE_STEP = 0.002;
/** Say where the selected box is, in the picture's own pixels. */ function $3ac76ebaf6b0238c$var$announceBox(prefix) {
    if (!$3ac76ebaf6b0238c$var$dom.live || !$3ac76ebaf6b0238c$var$state.image) return;
    if ($3ac76ebaf6b0238c$var$selected < 0) {
        $3ac76ebaf6b0238c$var$dom.live.textContent = prefix || 'No box selected.';
        return;
    }
    const source = (0, $7JAKl.sizeOf)($3ac76ebaf6b0238c$var$state.image);
    const r = $3ac76ebaf6b0238c$var$state.regions[$3ac76ebaf6b0238c$var$selected];
    const px = (value)=>Math.round(value);
    const text = `Box ${$3ac76ebaf6b0238c$var$selected + 1} of ${$3ac76ebaf6b0238c$var$state.regions.length}: ` + `${px(r.w * source.width)} by ${px(r.h * source.height)} pixels, ` + `${px(r.x * source.width)} from the left, ${px(r.y * source.height)} from the top.`;
    $3ac76ebaf6b0238c$var$dom.live.textContent = prefix ? `${prefix} ${text}` : text;
}
/**
 * Cover something up without a pointer.
 *
 * The picture takes focus like any control. N drops a box in the middle,
 * arrows move it, Shift and arrows size it, Enter steps to the next box,
 * Escape lets go and Delete (handled in wireDrawing) removes it. Every change
 * is read out with the box's size and place, which is how someone who cannot
 * see the box can still tell that it covers the token.
 */ function $3ac76ebaf6b0238c$var$wireKeyboard() {
    $3ac76ebaf6b0238c$var$dom.overlay.addEventListener('keydown', (event)=>{
        if (!$3ac76ebaf6b0238c$var$composed) return;
        const step = event.altKey ? $3ac76ebaf6b0238c$var$FINE_STEP : $3ac76ebaf6b0238c$var$KEY_STEP;
        const box = $3ac76ebaf6b0238c$var$selected >= 0 ? $3ac76ebaf6b0238c$var$state.regions[$3ac76ebaf6b0238c$var$selected] : null;
        let changed = false;
        let prefix = '';
        switch(event.key){
            case 'n':
            case 'N':
                {
                    // Staggered, so a second box does not land exactly on the first.
                    const offset = $3ac76ebaf6b0238c$var$state.regions.length % 5 * 0.03;
                    $3ac76ebaf6b0238c$var$state.regions.push({
                        x: 0.4 + offset,
                        y: 0.4 + offset,
                        w: 0.2,
                        h: 0.1
                    });
                    $3ac76ebaf6b0238c$var$selected = $3ac76ebaf6b0238c$var$state.regions.length - 1;
                    changed = true;
                    prefix = 'Added.';
                    break;
                }
            case 'Enter':
                if (!$3ac76ebaf6b0238c$var$state.regions.length) return;
                $3ac76ebaf6b0238c$var$selected = ($3ac76ebaf6b0238c$var$selected + 1) % $3ac76ebaf6b0238c$var$state.regions.length;
                break;
            case 'Escape':
                if ($3ac76ebaf6b0238c$var$selected < 0) return;
                $3ac76ebaf6b0238c$var$selected = -1;
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    if (!box) return;
                    const dx = event.key === 'ArrowLeft' ? -step : event.key === 'ArrowRight' ? step : 0;
                    const dy = event.key === 'ArrowUp' ? -step : event.key === 'ArrowDown' ? step : 0;
                    if (event.shiftKey) {
                        box.w = Math.min(1 - box.x, Math.max($3ac76ebaf6b0238c$var$MIN_REGION, box.w + dx));
                        box.h = Math.min(1 - box.y, Math.max($3ac76ebaf6b0238c$var$MIN_REGION, box.h + dy));
                    } else {
                        box.x = Math.min(1 - box.w, Math.max(0, box.x + dx));
                        box.y = Math.min(1 - box.h, Math.max(0, box.y + dy));
                    }
                    changed = true;
                    break;
                }
            default:
                return;
        }
        event.preventDefault();
        $3ac76ebaf6b0238c$var$paintBoxCount();
        if (changed) $3ac76ebaf6b0238c$var$schedule();
        else $3ac76ebaf6b0238c$var$drawOverlay();
        $3ac76ebaf6b0238c$var$announceBox(prefix);
    });
}
function $3ac76ebaf6b0238c$var$removeRegion(index) {
    $3ac76ebaf6b0238c$var$state.regions.splice(index, 1);
    $3ac76ebaf6b0238c$var$selected = -1;
    $3ac76ebaf6b0238c$var$paintBoxCount();
    $3ac76ebaf6b0238c$var$render();
}
function $3ac76ebaf6b0238c$var$paintBoxCount() {
    const count = $3ac76ebaf6b0238c$var$state.regions.length;
    $3ac76ebaf6b0238c$var$dom.boxCount.textContent = count === 0 ? 'Drag across the picture to cover something up.' : `${count} ${count === 1 ? 'box' : 'boxes'}${$3ac76ebaf6b0238c$var$selected >= 0 ? ', one selected. Delete removes it.' : '.'}`;
    $3ac76ebaf6b0238c$var$dom.undo.disabled = count === 0;
    $3ac76ebaf6b0238c$var$dom.clearBoxes.disabled = count === 0;
}
/* ---------------------------------------------------------------- controls */ function $3ac76ebaf6b0238c$var$syncControls() {
    $3ac76ebaf6b0238c$var$dom.redactColourRow.hidden = $3ac76ebaf6b0238c$var$state.redactMode !== 'fill';
    $3ac76ebaf6b0238c$var$dom.backdropColourRow.hidden = $3ac76ebaf6b0238c$var$state.backdrop !== 'solid';
    $3ac76ebaf6b0238c$var$dom.paddingValue.textContent = `${Math.round($3ac76ebaf6b0238c$var$state.padding * 100)}%`;
    $3ac76ebaf6b0238c$var$dom.radiusValue.textContent = `${Math.round($3ac76ebaf6b0238c$var$state.radius * 1000) / 10}%`;
    // Without a backdrop the rest of the card has nothing to act on; see
    // dressed() in tools/compose.js. Disabled rather than hidden, so it is
    // clear what choosing a backdrop would open up.
    const plain = $3ac76ebaf6b0238c$var$state.backdrop === 'off';
    for (const control of [
        $3ac76ebaf6b0238c$var$dom.padding,
        $3ac76ebaf6b0238c$var$dom.radius,
        $3ac76ebaf6b0238c$var$dom.shadow,
        $3ac76ebaf6b0238c$var$dom.bar,
        $3ac76ebaf6b0238c$var$dom.ratio
    ]){
        control.disabled = plain;
        control.parentElement.classList.toggle('opacity-50', plain);
    }
    // The one thing about this page that is a security claim rather than a
    // preference, so it is stated plainly and only where it applies.
    $3ac76ebaf6b0238c$var$dom.redactWarning.hidden = $3ac76ebaf6b0238c$var$state.redactMode === 'fill';
}
/**
 * The width to draw the screenshot at when saving.
 *
 * Every measurement in the layout is a multiple of this width, so a canvas that
 * came out twice as tall as allowed is fixed by halving it. Area grows with the
 * square, hence the root. One correction is exact rather than approximate,
 * because nothing in the layout is anything but linear.
 */ function $3ac76ebaf6b0238c$var$exportWidth() {
    const source = (0, $7JAKl.sizeOf)($3ac76ebaf6b0238c$var$state.image);
    const width = Math.min(source.width, $3ac76ebaf6b0238c$var$MAX_EXPORT_WIDTH);
    const box = (0, $75bc29bc43799f66$export$b3219800bda33a1f)($3ac76ebaf6b0238c$var$state, width);
    const over = Math.max(Math.max(box.outerW, box.outerH) / $3ac76ebaf6b0238c$var$MAX_CANVAS_EDGE, Math.sqrt(box.outerW * box.outerH / $3ac76ebaf6b0238c$var$MAX_CANVAS_AREA), 1);
    return over > 1 ? Math.max(1, Math.floor(width / over * 0.995)) : width;
}
function $3ac76ebaf6b0238c$var$exportSize() {
    const box = (0, $75bc29bc43799f66$export$b3219800bda33a1f)($3ac76ebaf6b0238c$var$state, $3ac76ebaf6b0238c$var$exportWidth());
    return {
        width: box.outerW,
        height: box.outerH
    };
}
/**
 * Draw and encode the picture at full size.
 *
 * Shared by the download button and the account button, so the file that gets
 * uploaded is byte for byte the one that would have been downloaded.
 */ async function $3ac76ebaf6b0238c$var$renderOutput() {
    const format = $3ac76ebaf6b0238c$var$FORMATS[$3ac76ebaf6b0238c$var$dom.format.value] || $3ac76ebaf6b0238c$var$FORMATS['image/png'];
    const full = (0, $75bc29bc43799f66$export$f672e0b6f7222cd7)($3ac76ebaf6b0238c$var$state, $3ac76ebaf6b0238c$var$exportWidth());
    const blob = await (0, $7JAKl.encode)(full.canvas, $3ac76ebaf6b0238c$var$dom.format.value, format.quality);
    return {
        blob: blob,
        name: (0, $7JAKl.renameExtension)($3ac76ebaf6b0238c$var$state.file.name, format.extension),
        width: full.canvas.width,
        height: full.canvas.height
    };
}
async function $3ac76ebaf6b0238c$var$save() {
    if (!$3ac76ebaf6b0238c$var$state.image) return;
    $3ac76ebaf6b0238c$var$dom.save.disabled = true;
    $3ac76ebaf6b0238c$var$setError('');
    try {
        const out = await $3ac76ebaf6b0238c$var$renderOutput();
        (0, $7JAKl.saveBlob)(out.blob, out.name);
        $3ac76ebaf6b0238c$var$dom.meta.textContent = `Saved ${out.width} x ${out.height}, ${(0, $7JAKl.formatBytes)(out.blob.size)}`;
    } catch (err) {
        $3ac76ebaf6b0238c$var$setError(err.message || 'Could not render the picture at full size');
    } finally{
        $3ac76ebaf6b0238c$var$dom.save.disabled = false;
    }
}
function $3ac76ebaf6b0238c$var$setError(message) {
    $3ac76ebaf6b0238c$var$dom.error.hidden = !message;
    $3ac76ebaf6b0238c$var$dom.error.textContent = message || '';
}
function $3ac76ebaf6b0238c$var$reset() {
    if ($3ac76ebaf6b0238c$var$state.image?.close) $3ac76ebaf6b0238c$var$state.image.close();
    $3ac76ebaf6b0238c$var$state.image = null;
    $3ac76ebaf6b0238c$var$state.file = null;
    $3ac76ebaf6b0238c$var$state.regions = [];
    $3ac76ebaf6b0238c$var$selected = -1;
    $3ac76ebaf6b0238c$var$drawing = null;
    $3ac76ebaf6b0238c$var$composed = null;
    $3ac76ebaf6b0238c$var$dom.workspace.hidden = true;
    $3ac76ebaf6b0238c$var$dom.empty.hidden = false;
    $3ac76ebaf6b0238c$var$dom.meta.textContent = '';
    $3ac76ebaf6b0238c$var$setError('');
    $3ac76ebaf6b0238c$var$paintBoxCount();
}
async function $3ac76ebaf6b0238c$var$open([file]) {
    if (!file) return;
    $3ac76ebaf6b0238c$var$reset();
    $3ac76ebaf6b0238c$var$state.file = file;
    try {
        $3ac76ebaf6b0238c$var$state.image = await (0, $7JAKl.decode)(file);
    } catch (err) {
        $3ac76ebaf6b0238c$var$setError(err.message || 'Could not read this image');
        return;
    }
    $3ac76ebaf6b0238c$var$dom.empty.hidden = true;
    $3ac76ebaf6b0238c$var$dom.workspace.hidden = false;
    $3ac76ebaf6b0238c$var$render();
}
function $3ac76ebaf6b0238c$var$fillBackdrops() {
    $3ac76ebaf6b0238c$var$dom.backdrop.innerHTML = '';
    for (const backdrop of (0, $75bc29bc43799f66$export$e9828e0bb5e4794c)){
        const option = document.createElement('option');
        option.value = backdrop.id;
        option.textContent = backdrop.label;
        $3ac76ebaf6b0238c$var$dom.backdrop.appendChild(option);
    }
    $3ac76ebaf6b0238c$var$dom.backdrop.value = $3ac76ebaf6b0238c$var$state.backdrop;
}
function $3ac76ebaf6b0238c$var$init() {
    if (!$3ac76ebaf6b0238c$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.initColourPicker)();
    (0, $65gAn.wirePicker)({
        zone: $3ac76ebaf6b0238c$var$dom.zone,
        input: $3ac76ebaf6b0238c$var$dom.input,
        multiple: false,
        onFiles: $3ac76ebaf6b0238c$var$open
    });
    $3ac76ebaf6b0238c$var$wireDrawing();
    $3ac76ebaf6b0238c$var$wireKeyboard();
    $3ac76ebaf6b0238c$var$fillBackdrops();
    $3ac76ebaf6b0238c$var$syncControls();
    $3ac76ebaf6b0238c$var$paintBoxCount();
    const bind = (element, key, read, immediate)=>{
        element.addEventListener('input', ()=>{
            $3ac76ebaf6b0238c$var$state[key] = read(element);
            $3ac76ebaf6b0238c$var$syncControls();
            if (immediate) $3ac76ebaf6b0238c$var$render();
            else $3ac76ebaf6b0238c$var$schedule();
        });
    };
    bind($3ac76ebaf6b0238c$var$dom.redactMode, 'redactMode', (e)=>e.value, true);
    bind($3ac76ebaf6b0238c$var$dom.redactColour, 'redactColour', (e)=>e.value, false);
    bind($3ac76ebaf6b0238c$var$dom.backdrop, 'backdrop', (e)=>e.value, true);
    bind($3ac76ebaf6b0238c$var$dom.backdropColour, 'backdropColour', (e)=>e.value, false);
    bind($3ac76ebaf6b0238c$var$dom.padding, 'padding', (e)=>Number(e.value) / 100, false);
    bind($3ac76ebaf6b0238c$var$dom.radius, 'radius', (e)=>Number(e.value) / 1000, false);
    bind($3ac76ebaf6b0238c$var$dom.shadow, 'shadow', (e)=>e.value, true);
    bind($3ac76ebaf6b0238c$var$dom.ratio, 'ratio', (e)=>e.value, true);
    // One control for two values: whether there is a bar, and what shade it is.
    $3ac76ebaf6b0238c$var$dom.bar.addEventListener('input', ()=>{
        $3ac76ebaf6b0238c$var$state.frame = $3ac76ebaf6b0238c$var$dom.bar.value === 'none' ? 'none' : 'bar';
        $3ac76ebaf6b0238c$var$state.barColour = $3ac76ebaf6b0238c$var$dom.bar.value === 'dark' ? '#1e293b' : '#e2e8f0';
        $3ac76ebaf6b0238c$var$render();
    });
    $3ac76ebaf6b0238c$var$dom.undo.addEventListener('click', ()=>{
        if ($3ac76ebaf6b0238c$var$state.regions.length) $3ac76ebaf6b0238c$var$removeRegion($3ac76ebaf6b0238c$var$state.regions.length - 1);
    });
    $3ac76ebaf6b0238c$var$dom.clearBoxes.addEventListener('click', ()=>{
        $3ac76ebaf6b0238c$var$state.regions = [];
        $3ac76ebaf6b0238c$var$selected = -1;
        $3ac76ebaf6b0238c$var$paintBoxCount();
        $3ac76ebaf6b0238c$var$render();
    });
    $3ac76ebaf6b0238c$var$dom.save.addEventListener('click', $3ac76ebaf6b0238c$var$save);
    $3ac76ebaf6b0238c$var$dom.reset.addEventListener('click', $3ac76ebaf6b0238c$var$reset);
    (0, $iPsZ0.wireCopy)({
        button: document.getElementById('shotCopy'),
        mirror: $3ac76ebaf6b0238c$var$dom.save,
        collect: ()=>$3ac76ebaf6b0238c$var$state.image ? $3ac76ebaf6b0238c$var$renderOutput() : null
    });
    (0, $1Euqv.wireAccountSave)({
        button: $3ac76ebaf6b0238c$var$dom.saveAccount,
        panel: $3ac76ebaf6b0238c$var$dom.savePanel,
        list: $3ac76ebaf6b0238c$var$dom.saveList,
        error: $3ac76ebaf6b0238c$var$dom.saveError,
        collect: async ()=>$3ac76ebaf6b0238c$var$state.image ? [
                await $3ac76ebaf6b0238c$var$renderOutput()
            ] : []
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $3ac76ebaf6b0238c$var$init);
else $3ac76ebaf6b0238c$var$init();

})();
//# sourceMappingURL=tools-screenshot.a0731af4.js.map
